import { NotFoundError } from '@/domain/errors/not-found-error.js';
import type { SapConnectionView, TestSapConnectionParams, TestSapConnectionResult, UpsertSapConnectionParams } from '@/domain/models/sap-connection.js';
import type { HttpClient } from '@/domain/protocols/http-client.js';
import type { SapConnectionRepository } from '@/domain/repositories/sap-connection-repository.js';

export class SapConnectionRepositoryImpl implements SapConnectionRepository {
    constructor(private readonly httpClient: HttpClient) {}

    public async get(clientId: string): Promise<SapConnectionView | null> {
        try {
            const response = await this.httpClient.request<SapConnectionView>({
                url: `/api/clients/${encodeURIComponent(clientId)}/sap-connection`,
                method: 'GET'
            });
            return response.body;
        } catch (error) {
            if (error instanceof NotFoundError) {
                return null;
            }
            throw error;
        }
    }

    public async upsert(clientId: string, params: UpsertSapConnectionParams): Promise<SapConnectionView> {
        const response = await this.httpClient.request<SapConnectionView>({
            url: `/api/clients/${encodeURIComponent(clientId)}/sap-connection`,
            method: 'PUT',
            body: params
        });
        return response.body;
    }

    public async test(clientId: string, params: TestSapConnectionParams): Promise<TestSapConnectionResult> {
        const response = await this.httpClient.request<TestSapConnectionResult>({
            url: `/api/clients/${encodeURIComponent(clientId)}/sap-connection/test`,
            method: 'POST',
            body: params
        });
        return response.body;
    }
}
